import { render, staticRenderFns } from "./GameEventBox.vue?vue&type=template&id=c29d8892&scoped=true"
import script from "./GameEventBox.vue?vue&type=script&lang=ts"
export * from "./GameEventBox.vue?vue&type=script&lang=ts"
import style0 from "./GameEventBox.vue?vue&type=style&index=0&id=c29d8892&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c29d8892",
  null
  
)

export default component.exports